import React from 'react';

export const YOUTUBE_VIDEO_ID = 'QprhXgd5HP8';

export const heroFeaturesMobile = [
  'Safe, outdoor arena setting',
  'Individual and group sessions',
  'Experienced and caring volunteers',
];

export const heroFeaturesDesktop = [
  'Comprehensive therapeutic programs',
  'Safe, indoor arena setting',
  'Experienced and caring volunteers',
];

export const stats = [
  { value: '30+', label: 'Years of Service' },
  { value: '50+', label: 'Volunteers' },
  { value: '500+', label: 'Lives Touched' },
];

export const volunteerRoles = [
  {
    title: 'Horse Leader',
    description: 'Guide horses safely alongside riders during sessions',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M13 9l3 3m0 0l-3 3m3-3H8m13 0a9 9 0 11-18 0 9 9 0 0118 0z" />
    ),
  },
  {
    title: 'Side Walker',
    description: 'Assist riders with balance and riding instructions',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
    ),
  },
  {
    title: 'Groomer',
    description: 'Help with grooming and caring for our horses',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M5 3v4M3 5h4M6 17v4m-2-2h4m5-16l2.286 6.857L21 12l-5.714 2.143L13 21l-2.286-6.857L5 12l5.714-2.143L13 3z" />
    ),
  },
];

export const programComponents = [
  {
    title: 'Warm-up Exercises',
    description: 'Lessons begin with instructor-led basic stretching followed by light warm-up exercises to prepare riders.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 10V3L4 14h7v7l9-11h-7z" />
    ),
  },
  {
    title: 'Horsecare Training',
    description: 'Learn horse anatomy, grooming, feeding, and saddling fundamentals before riding instruction.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
    ),
  },
  {
    title: 'Horseback Riding',
    description: 'Fun activities including horseback games, obstacle courses, and gymnastic movements on horseback.',
    icon: (
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2}
        d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z" />
    ),
  },
];
